/*
 * @Description: 对比两个对象值是否相同
 */
export function objectCompare(source,comparison) {
  let getDataType = (data) => {
    const temp = Object.prototype.toString.call(data);
    const type = temp.match(/\b\w+\b/g);
    return (type.length < 2) ? 'Undefined' : type[1];
  }
  let iterable = (data) => {
    return ['Object', 'Array'].includes(getDataType(data));
  }

  if (!iterable(source)) {
    throw new Error(`source should be a Object or Array , but got ${getDataType(source)}`);
  }
  if (getDataType(source) !== getDataType(comparison)) {
    return true;
  }
  const sourceKeys = Object.keys(source);
  const comparisonKeys = Object.keys({ ...source, ...comparison });
  if (sourceKeys.length !== comparisonKeys.length) {
    return true;
  }
  return comparisonKeys.some(key => {
    if (iterable(source[key])) {
      return objectCompare(source[key], comparison[key]);
    } else {
      return source[key] !== comparison[key];
    }
  });
}